export class EditAmountDto {
    newAmount: number;

    constructor(newAmount: number) {
        this.newAmount = newAmount;
    }
}